import React, { useState } from "react";
import { MdExpandMore } from "react-icons/md";
import styles from "./FAQ.module.css";

interface FAQItem {
  id: number;
  question: string;
  answer: string;
}

export default function FAQ() {
  const [openId, setOpenId] = useState<number | null>(1);

  const faqs: FAQItem[] = [
    {
      id: 1,
      question: "Where can I avail tyre services with Mechmiles?",
      answer:
        "You can avail services PAN India, across our centres situated in 15 states and 36 cities. These outlets are present at the leading Oil Marketing companies - IOCL, HPCL, BPCL and Nayara Fuel stations. We are working towards scaling our outlets and tying up with other players in India.",
    },
    {
      id: 2,
      question: "Why should I choose Mechmiles?",
      answer:
        "Mechmiles offers the best Tyres and services with use of latest tools and equipment too at a fair and flexible price. You end up saving up to 10-15% compared to what is charged at a roadside Puncture person.",
    },
    {
      id: 3,
      question: "How can you offer upto 10-15% savings on services?",
      answer:
        "We have fixed rate cards and the same is monitored on a regular basis. Over the last 9-10 years we have built an ecosystem conducive to our partners, customers and ourselves.",
    },
    {
      id: 4,
      question:
        "Can I avail tyre services in Pune, although I am based out of Mumbai.",
      answer:
        "Yes, you can avail Tyre related services anywhere in India; the choice is yours. We are a location independent network of Tyre services company. You have to login into our app and opt for a service station which suits your needs",
    },
    {
      id: 5,
      question:
        "How is Mechmiles different from other Tyre service outlets out there?",
      answer:
        "Built on a fulfillment model, our tire service outlets have flourished over the past 9-10 years. We've nurtured relationships with partners across India, engaging in successful business dealings for many years. This extensive experience allows us to confidently position ourselves as industry leaders, outshining other players in the market today.",
    },
    {
      id: 6,
      question: "How can I schedule a tire-related service with Mechmiles?",
      answer:
        "Booking tire-related services is convenient through either our website or our user-friendly Android mobile application.",
    },
    {
      id: 7,
      question:
        "Does your application showcase tyres that are best suited for my vehicle?",
      answer:
        "Yes, we have a comprehensive list of Vehicles in our database and we keep updating it on a regular basis. We understand that tyres form the most important part of the vehicle. Hence, they have to be monitored and a best tyre will keep away from accidents. On our application and website, the vehicles are mapped with the tyres with recommendation for your vehicle.",
    },
    {
      id: 8,
      question: "Would I be charged in case I cancel the services?",
      answer:
        "We would like to provide our services to you at all times. In case you wish to cancel we will not charge you for the same, however we would like to know the reason for the cancellation and understand your requirement.",
    },
    {
      id: 9,
      question: "What if your product or services are not up to the mark?",
      answer:
        "We always try to provide the best of the services and products. In business we cannot have 100% appreciation from our customers, but we strive to improve the quality by taking timely feedback from our esteemed customers and rectifying the same on a real time basis. We will do our best to keep you happy and handle your query as it comes.",
    },
  ];

  const handleToggle = (id: number) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <section className={styles.faqSection}>
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>Frequently asked questions</h2>
        <div className={styles.faqList}>
          {faqs.map((faq) => {
            const isOpen = openId === faq.id;
            return (
              <div key={faq.id} className={styles.faqCard}>
                <button
                  onClick={() => handleToggle(faq.id)}
                  className={styles.faqQuestionBtn}
                  aria-expanded={isOpen}
                >
                  <span className={styles.questionText}>{faq.question}</span>
                  <span
                    className={`${styles.chevronIcon} ${isOpen ? styles.chevronRotated : ""}`}
                  >
                    <MdExpandMore size={24} />
                  </span>
                </button>
                <div
                  className={`${styles.answerWrapper} ${isOpen ? styles.open : ""}`}
                >
                  <div className={styles.answerText}>{faq.answer}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
